<div class="card user-card">
  <div class="background bg-info">
    <img
      [src]="user.avatar_url"
      alt="avatar"
      class="img-fluid bg-dark profile-pic border-2 border-white"
    />
  </div>

  <div class="card-body">
    <h5 class="card-title">
      {{ user.name }}
    </h5>
    <p class="card-text">Bio: {{ user.bio }}</p>
    <p class="card-text">Company: {{ user.company }}</p>
    <p class="card-text">Blog: {{ user.blog }}</p>
    <p class="card-text">Updated at: {{ user.updated_at | date: "short" }}</p>
  </div>
</div>
